module.exports = __webpack_public_path__ + "img/atempt-warning.7635781f.svg";